<template lang="pug">
section.visible__layout
  h1.h1-title {{ $t('common.myPoints') }}

  spacer(size="40px")

  .tab-controls
    button.tab-controls__item(@click="active = 0;", :class="{ 'active': active === 0 }")
      span.tab-controls__item__title {{ $t('common.balance') }}
      span.tab-controls__item__anchor
    button.tab-controls__item(@click="active = 1;", :class="{ 'active': active === 1 }")
      span.tab-controls__item__title {{ $t('common.opHistory') }}
      span.tab-controls__item__anchor

  spacer(size="50px")

  div
    //- .row c-d line
      .row-objects_cat
        a.button.button_secondary-round.uppercase.semi-bold(@click="active=0;",
        href="#", :class="{ 'active': active == 0 }") {{$t('common.balance')}}

        a.button.button_secondary-round.uppercase.semi-bold(@click="active=1;", href="#",
        :class="{ 'active': active == 1 }") {{$t('common.opHistory')}}
    .tabs
      .tab(v-if="active==0")
        //- .tab__title {{$t('common.balance')}}
        .tab__content
          h2.balance-title(v-if="profile") {{$t('msgs.youHave')}}:
            .bordered-part {{profile.balance}} {{$t('msgs.points')}}
          .points
            .semi-strong {{$t('msgs.whyNeedPoints')}}
            ul
              li {{$t('msgs.whyNeedPoints1')}}
              li {{$t('msgs.whyNeedPoints2')}}
          button.btn(@click="openCode" style="color: unset;") {{$t('msgs.activateCode')}}
          popup-code(v-if="isCodeOpen", @close="isCodeOpen=false;")
      .tab(v-if="active==1")
        //- .tab__title {{$t('common.opHistory')}}
        .tab__content
          skeleton(v-if="loading", :type="'transactions'", :count="20")
          table(v-if="!loading")
            thead
              tr
                th {{$t('common.date')}}
                th {{$t('common.debet')}}
                th {{$t('common.credit')}}
                th {{$t('common.summ')}}
                th {{$t('common.action')}}
            tbody
              tr(v-for="item in transitions")
                td {{item.createdAt}}
                td {{getPrice(item.credit)}}
                td {{getPrice(item.debit)}}
                td {{item.sum}} {{$t('msgs.points')}}
                td(v-if="item.message === 'i18n.transactions.transfer_user'")
                  | {{ $t(`transactions.${item.message}`) }}
                td(v-else) {{item.message}}

          button.load-more(
            @click="getMoreTransitons",
            :class="{ 'load-more_loading': loadingMore }",
            :disabled="lastPage === page"
          ) {{ $t('downloadMore') }}

          //- .pag(v-if="lastPage && lastPage > 1")
              pagination(:current="page", :pages="lastPage", @load="toPage")

</template>

<script>
import { mapGetters } from 'vuex';
import popupCode from '@/components/popups/code.vue';
import Pagination from '@/components/Pagination';
import Skeleton from '@/components/Skeleton';
import API from '@/api/api';

export default {
  components: {
    popupCode,
    Pagination,
    Skeleton,
  },
  data() {
    return {
      active: 0,
      transitions: null,
      isCodeOpen: false,
      cabinet: null,
      profile: null,
      page: 1,
      lastPage: null,
      loading: true,

      loadingMore: false,
    };
  },
  mounted() {
    this.cabinet = this.getCabinet;
    if (this.cabinet) {
      this.profile = this.cabinet.profile;
    }
    this.getTransitons();
  },
  computed: {
    ...mapGetters({
      getCabinet: 'getCabinet',
      getLayout: 'getLayout',
    }),
  },
  watch: {
    getCabinet(val) {
      this.cabinet = val;
      this.profile = val.profile;
    },
  },
  methods: {
    async getMoreTransitons() {
      if (this.loadingMore) {
        return;
      }
      this.loadingMore = true;
      try {
        this.page += 1;
        const data = await API.getTransactions({
          page: this.page,
        });
        this.transitions = [...this.transitions, ...data.data];
        this.lastPage = data.last_page;
      } catch (e) {
        console.log(e);
        global.alert('Произошла ошибка во время загрузки данных');
        this.page -= 1;
      } finally {
        this.loadingMore = false;
      }
    },
    async getTransitons(page) {
      this.loading = true;
      const data = await API.getTransactions({
        page,
      });
      if (data && data.data) {
        this.transitions = data.data;
        this.lastPage = data.last_page;
        this.loading = false;
      }
    },
    getPrice(value) {
      if (value || value === 0) {
        let val = (value / 100).toFixed(2).replace('.', ',');
        val = `${val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')} ${this.getLayout.currency_symbol ? this.getLayout.currency_symbol : this.$t('currency.rub')}`;
        return val;
      }
      return '';
    },
    toPage(page) {
      this.page = page;
      this.transitions = null;
      this.getTransitons(page);
    },
    openCode() {
      this.isCodeOpen = true;
    },
  },
};
</script>

<style lang="scss">
.load-more {
  margin: 15px auto 0;

  cursor: pointer;
  user-select: none;
  text-decoration: none;
  appearance: none;

  transition: all .2s;

  border: none;
  outline: none;
  background-color: #ffde00;
  color: #333;
  font-size: 1rem;
  height: 40px;
  padding: 0 25px;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  &:hover {
    opacity: .8;
  }
  &:active {
    transform: translateY(-3px);
  }
  &:focus {
    box-shadow: 0 0 10px 1px #ffde00;
  }
  &:disabled {
    filter: grayscale(1);
    opacity: .75;
    box-shadow: none;
    transform: none;
    cursor: not-allowed;
  }
}
.balance-title {
  line-height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-weight: 600;

  .bordered-part {
    margin-left: 20px;
    padding: 0 20px;
    border-radius: 5px;
    border: 2px #ffcc00 solid;
  }
}
.points {
  padding: 50px 0 30px;
  .semi-strong {
    font-weight: 600;
    padding-bottom: 20px;
  }
  ul {
    line-height: 50px;
    li {
      display: flex;
      align-items: center;
      &:before {
        content: '';
        height: 20px;
        width: 20px;
        margin-right: 10px;
        background: url('../../../../common/assets/img/point.png') no-repeat;
      }
    }
  }
}
table {
  border-collapse: collapse;
  width: 100%;
  th {
    font-weight: 500;
  }
  tbody > tr {
    transition: background-color 0.15s ease-in-out;
    &:nth-child(2n - 1) {
      background-color: rgb(247, 247, 247);
    }
    &:hover {
      background-color: #e0e0e0;
    }
  }
  th, td {
    font-size: 14px;
    padding: 15px;
    align-items: center;
    height: 40px;
    text-align: left;
    border-bottom: 1px solid #ddd !important;

  }
}

</style>
